// Cart page: quantity, frequency and remove update the line in place, sharing the cart drawer's behaviour (CartView in
// assets/purolabs-cart.js): one /cart/change.js request re-renders this section and the drawer, changes are announced
// with Shopify's standard cart event, and changes made elsewhere refresh the page's contents.
import { CartView } from '@purolabs/cart';

class CartPage extends CartView {}

if (!customElements.get('pl-cart-page')) customElements.define('pl-cart-page', CartPage);
